import TextArea from 'antd/es/input/TextArea'
import { Form, Popover, Typography } from 'antd'
import { useTranslation } from 'react-i18next';

const TRUNCATE_LENGTH = 50

const TextareaForm = (props) => {
    const { t } = useTranslation();
    const { values, disabled = false, parent = "", tableLabel = "", label = "" } = props
    let currentValue = values?.[props.id]

    if (disabled) {
        const text = currentValue == null ? '' : String(currentValue)
        const isLong = text.length > TRUNCATE_LENGTH
        const truncated = isLong ? text.slice(0, TRUNCATE_LENGTH) + '...' : text
        const popoverContent = (
            <div style={{ width: 360, maxHeight: '60vh', overflowY: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word', padding: "12px" }}>
                <div style={{fontWeight: "600", fontSize: "16px"}}>{label || 'Details'}</div>
                {text}
            </div>
        )
        return (
            <span>
                {truncated}
                {isLong && (
                    <Popover
                        content={popoverContent}
                        // title={label || 'Details'}
                        trigger="click"
                        placement="topLeft"
                        styles={{ body: { padding: 16 } }}
                    >
                        <span
                            role="button"
                            tabIndex={0}
                            onClick={(e) => e.stopPropagation()}
                            style={{ marginLeft: 6, color: '#1677ff', cursor: 'pointer', textDecoration: 'underline' }}
                        >
                            {t('View More')}
                        </span>
                    </Popover>
                )}
            </span>
        )
    }

    return (
        <>
            <Form.Item label="" preserve={false} style={{ marginBottom: 0 }}>
                <TextArea disabled={disabled} rows={props.rows || 2} value={currentValue ?? ""} onChange={(e) => props.handleChange(props.id, e.target.value, props.documentId)} />
            </Form.Item>
        </>

    )
}

export default TextareaForm
